<template>
  <v-app class="pa-3">
    <v-card
      class="mx-auto justify-center mb-6"
      max-width="70%"
      flat
      width="70%"
    >
      <v-col
        class="xs"
        cols="12"
        md="12"
        sm="12"
      >
        <v-row>
          <v-img
            height="300"
            contain
            src="https://image.freepik.com/free-vector/403-error-forbidden-with-police-concept-illustration_114360-1884.jpg"
          />
        </v-row>
        <v-row>
          <v-card-title
            class="justify-center mx-auto  my-4"
            grey
            darken-3
          >
            {{ $t('notAccessThisPage') }}
          </v-card-title>
          <v-col
            class="px-4  xs pt-0"
            cols="12"
          >
            <v-btn
              :loading="loading"
              block
              color="deep-purple accent-2 mr-0"
              @click="$router.go(back)"
            >
              {{ $t('back') }}
            </v-btn>
          </v-col>
        </v-row>

        <v-divider />

        <v-row>
          <v-col
            class="xs"
            style="display: flex"
            cols="12"
            md="12"
            sm="12"
          >
            <div class="mx-auto justify-center deep-purple--text text--lighten-2 text-subtitle-1 mt-2">
              Abriron Cloud Panel V 1.0
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </v-app>
</template>

<script>
  import General from '../../../../Mixins/general'
  import menu from '../../../../menu.json'
  export default {
    name: 'Product',
    components: {
    },
    mixins: [General],
    props: ['roleProp'],
    data: () => ({
      options: {
        locale: 'en-US',
        prefix: '',
        suffix: ' ',
        precision: 0,
      },
      render: false,
      isLoading: false,
      alert: false,
      permissions: [],
      id: null,
      tag: null,
      search: null,
      valid: null,
      back: -2,
      message: null,
      alertType: null,
      items: menu,
      name: null,
      type: null,
      role: null,
      status: 'active',
      group: null,
      caseSensitive: false,
      loading: false,
    }),
    computed: {
    },
    watch: {
      // permissions () {
      // },
    },
    beforeMount () {
      this.back = this.$route.query.back
    },
    mounted () {
    },
  }
</script>

<style scoped>

</style>
